import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import { EPSG } from "../../projection";
export class ClientLayer {
    constructor() {
        this.raw = new VectorLayer({
            source: new VectorSource()
        });
        this.source = this.raw.getSource();
        this.projection = EPSG(3857);
        this.name = 'clientlayerbase';
    }
    clear() {
        this.source.clear();
    }
    changed() {
        this.raw.changed();
    }
}
